import React, { useState, useEffect } from 'react';
import { Save, FileText, CheckCircle2 } from 'lucide-react';
import { api } from '../../api/client';
import { showToast } from '../../components/common/Toast';

export default function AdminCmsPage() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/cms/settings')
      .then((res) => {
        if (res?.success) setSettings(res.settings || {});
      })
      .catch((err) => showToast(err.message, 'error'))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (key, val) => {
    setSettings((prev) => ({ ...prev, [key]: val }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put('/cms/settings', { settings });
      if (res?.success) {
        showToast('Kontent muvaffaqiyatli saqlandi!', 'success');
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="py-12 text-center text-slate-400">Kontent sozlamalari yuklanmoqda...</div>;
  }

  return (
    <form onSubmit={handleSave} className="space-y-8 max-w-4xl">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-serif text-lg font-bold text-slate-900">
            Sayt Asosiy Kontenti (CMS)
          </h2>
          <p className="text-xs text-slate-500">
            Bosh sahifa matnlari, shiorlar va korporativ ko‘rsatkichlarni tahrirlash
          </p>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="inline-flex items-center px-5 py-2 text-xs font-semibold text-[#091322] bg-[#c5a880] hover:bg-[#d4b993] rounded shadow-sm transition-colors"
        >
          <Save className="w-4 h-4 mr-1.5" />
          {saving ? 'Saqlanmoqda...' : 'O‘zgarishlarni Saqlash'}
        </button>
      </div>

      {/* 1. Hero Section Texts */}
      <div className="bg-white rounded-lg border border-slate-200 shadow-2xs p-6 space-y-4 text-xs">
        <h3 className="font-serif font-bold text-slate-900 text-sm border-b pb-2 uppercase tracking-wider">
          Bosh Sahifa Hero Bloki
        </h3>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Sayt / Portal Nomi</label>
          <input
            type="text"
            value={settings.site_name || ''}
            onChange={(e) => handleChange('site_name', e.target.value)}
            className="w-full px-3 py-2 border rounded font-semibold text-slate-900 focus:border-[#c5a880]"
          />
        </div>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Bosh Shior (O‘zbekcha)</label>
          <input
            type="text"
            value={settings.site_tagline_uz || ''}
            onChange={(e) => handleChange('site_tagline_uz', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Bosh Shior (Ruscha)</label>
          <input
            type="text"
            value={settings.site_tagline_ru || ''}
            onChange={(e) => handleChange('site_tagline_ru', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Bosh Shior (Inglizcha)</label>
          <input
            type="text"
            value={settings.site_tagline_en || ''}
            onChange={(e) => handleChange('site_tagline_en', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>
      </div>

      {/* 2. SEO Metadata */}
      <div className="bg-white rounded-lg border border-slate-200 shadow-2xs p-6 space-y-4 text-xs">
        <h3 className="font-serif font-bold text-slate-900 text-sm border-b pb-2 uppercase tracking-wider">
          SEO & Qidiruv Tizimlari Sozlamalari
        </h3>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Meta Sarlavha (SEO Title)</label>
          <input
            type="text"
            value={settings.seo_meta_title || ''}
            onChange={(e) => handleChange('seo_meta_title', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>

        <div>
          <label className="block font-semibold text-slate-700 uppercase mb-1">Meta Tavsif (Meta Description)</label>
          <textarea
            rows={3}
            value={settings.seo_meta_description || ''}
            onChange={(e) => handleChange('seo_meta_description', e.target.value)}
            className="w-full px-3 py-2 border rounded focus:border-[#c5a880]"
          />
        </div>
      </div>
    </form>
  );
}
